import Api from '@/providers/Api';

export const logUserEvent = (eventType, params = {}) => {
  try {
    Api.logUserEvent(eventType, params);
  } catch (error) {
    process.env.NODE_ENV !== 'production' && console.error(error);
  }
};
